let uuid = null;

function setValue(value) {
  uuid = value;
}

function getValue() {
  return uuid;
}

const activeAnnotation = {
  setValue,
  getValue,
};

export default activeAnnotation;
